export const validateMod10 = (number: string): boolean => {
    const reverseNumber = [...number].slice(0, number.length - 1).reverse();
    let calc;
    let sum = 0;
    reverseNumber.forEach((val: any, i: number) => {
        calc = val * ((i + 1) % 2 ? 2 : 1);
        sum += Math.floor(calc / 10) + (calc % 10);
    });
    return Number(number.charAt(number.length - 1)) === (sum % 10 === 0 ? 0 : 10 - (sum % 10));
};

export const validateMod11 = (number: string): boolean => {
    let sum = 0;
    [...number].forEach((val: any, i: number) => {
        if (i !== number.length - 1) {
            sum += (7 - ((i + 2) % 6)) * val;
        }
    });
    return Number(number.charAt(number.length - 1)) === (sum % 11 === 0 ? 0 : 11 - (sum % 11));
};
